<template>

  <div class="layout-footer py-2">

    <div class="grid">

      <div class="col-12 md:col-3 py-3 text-center md:text-left">

        <div>
          <span style="--quadrado: 40px; vertical-align: middle" class="inline-block border-circle overflow-hidden">
            <img :src="empresa.imagen" alt="">
          </span>

          <span class="inline-block font-light ml-2" style="vertical-align: middle; font-size: 1.1em;">
            {{ empresa.nome }}<br>
            {{ $utils.formatCnpjCpf(empresa.cnpj) }}
          </span>
        </div>

        <Button v-if="typeof empresa.sobre != 'undefined' && empresa.sobre != ''" label="Sobre Nós?" class="p-button-text md:ml-3 text-white" @click="displaySobre = true"/>

      </div>

      <div class="col-12 md:col-5 text-center">
        
        <div class="mb-1">Formas de pagamentos</div>

        <div id="logos-formas-pagamento">
          <Image class="mb-2 md:mb-0 inline-block"
          :src="require('../assets/selos/visa.png')" 
            imageStyle="width:60px" />
          <Image class="mb-2 ml-3 md:ml-2 md:mb-0 inline-block"
            :src="require('../assets/selos/mastercard.png')" 
            imageStyle="width:60px" />
          <Image class="mb-2 ml-3 md:ml-2 md:mb-0 inline-block" 
            :src="require('../assets/selos/hipercard.png')" 
            imageStyle="width:60px" />
          <Image class="mb-2 ml-3 md:ml-2 md:mb-0 inline-block"
            :src="require('../assets/selos/americanexpress.jpeg')" 
            imageStyle="width:60px" />
          <Image class="mb-2 ml-3 md:ml-2 md:mb-0 inline-block" 
          :src="require('../assets/selos/elo.png')" 
            imageStyle="width:60px" />
          <Image class="mb-2 ml-3 md:ml-2 md:mb-0 inline-block" 
            :src="require('../assets/selos/pix.png')" 
            imageStyle="width:60px" />
        </div>

      </div>

      <!-- <div class="col-5 md:col-2 text-center">

        <div class="mb-1">Envios</div>

        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8Ivp6pjZP2Ka_m2xYDLpOp7l4Xd_xS748syEodl0WjMjSbNFfUdbkUpX3Xn09Fmt8w8Q&usqp=CAU"
          alt="Image Text" style="width:65px;" class="inline-block" />

      </div> -->

      <div class="col-12 md:col-2 text-center">

        <div class="mb-1">Selos de seguraça</div>

        <a href="https://www.google.com/transparencyreport/safebrowsing/diagnostic/?hl=pt-BR#url=loja.npc.software" target="_blank" class="inline-block" style="vertical-align: middle">
          <img src="https://ajuda.fastcommerce.com.br/images/Google_Loja_Segura.svg?cccfc=1"
            style="height: 35px; background: white;" alt="Seu pedido com Segurança" title="Site Seguro" />
        </a>

        <img src="https://ajuda.fastcommerce.com.br/images/100_https.svg?cccfc=1"
          style="height: 35px; background: white; vertical-align: middle" class="ml-2 inline-block" alt="Seu pedido com Segurança" title="Site Seguro">

      </div>

      <div class="col-12 text-center">
        <span style="color: rgb(118,118,118);">&copy; VIP Delivery - E-commerce - {{ $root.version }}</span>
      </div>

    </div>

  </div>

  <Dialog :position="$utils.isMobileCheck() ? 'bottom' : 'center'" v-model:visible="displaySobre"
    :style="{ width: '600px', 'max-width': '100%' }" :modal="true" :closable="true">
    <template #header>
      <h5 class="m-0 text-xl font-medium">
        <i class="pi pi-building" style="font-size: 1.3rem"></i> Sobre Nós
      </h5>
    </template>
    <div v-html="empresa.sobre.replace(/[\n]/g, '<br>')"></div>
  </Dialog>

</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {
      displaySobre: false,
      empresa: { foto: "", nomeEmpresa: "", cnpj: "" },
    };
  },
  mounted() {
    document.body.classList.add("with-footer");
  },
  watch: {
    "$auth.empresa": {
      handler: function (empresa) {
        if (this.$auth.existsEmpresa()) {
          this.empresa = empresa;
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .layout-footer {
    background-color: var(--primaryBackgroundColor, $primaryBackgroundColor);
    color: white;
  }

  .layout-footer > .grid {
    max-width: 1000px;
    margin: auto;
  }

  @media screen and (max-width: 500px) {

    #logos-formas-pagamento {
      width: 80%;
      margin: 0 auto;
    }

  }

</style>
